import { render, staticRenderFns } from "./restrictedSpace.vue?vue&type=template&id=2234051b&scoped=true"
import script from "./restrictedSpace.vue?vue&type=script&lang=js"
export * from "./restrictedSpace.vue?vue&type=script&lang=js"
import style0 from "./commonTable.css?vue&type=style&index=0&id=2234051b&prod&scoped=true&lang=css&external"
import style1 from "./restrictedSpace.vue?vue&type=style&index=1&id=2234051b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2234051b",
  null
  
)

export default component.exports